/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Instance from './instance';
import InstanceDetail from './instance-detail';
import InstanceUpdate from './instance-update';
import InstanceDeleteDialog from './instance-delete-dialog';

const InstanceRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Instance />} />
    <Route path="new" element={<InstanceUpdate />} />
    <Route path=":id">
      <Route index element={<InstanceDetail />} />
      <Route path="edit" element={<InstanceUpdate />} />
      <Route path="delete" element={<InstanceDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default InstanceRoutes;
